import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
  getTripDetailsV3,
  deleteTrip
} from "../../../store/actions/tripActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
const useStyles = makeStyles((theme) => ({
  info: {
    padding: 24,
    backgroundColor: '#d6def7',
    height: '100%',
    minHeight: 100,
    maxHeight: 100,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    color: '#0033cc',
    alignItems: 'center',
    fontWeight: 300
  }
}));
const DeleteTrip = (props) => {
  const { location, tripId, deleteOpen, dispatchTripDetailsAction, dispatchDeleteTrip, onDeleteSucees, onDeleteNo } = props;
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(deleteOpen);
  let confirmMessage = "Are you sure, you want to Delete the Trip?";
  let confirmTitle = "Delete Trip";
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const onConfirm = (confirm) => {
    if (confirm) {
      dispatchDeleteTrip(tripId, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces("Trip Deleted Suceessfully!");
          onDeleteSucees()
        } else {
        }
      },
        () => {
        })
    } else {
      onDeleteNo()
      //fetchTrip(tripId) 
    }
  }
  return (
    <>
      {open && <ConfirmDialog confirmOpen={open} confirmTitle={confirmTitle} confirmMessage={confirmMessage} onClose={onConfirm} />
      }    </>
  );
}
DeleteTrip.propTypes = {
  tripId: PropTypes.any.isRequired,
};
const DeleteTripWithRouter = withRouter(DeleteTrip);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchDeleteTrip: (tripId, onSuccess, onFailure) => { dispatch(deleteTrip(tripId, onSuccess, onFailure)) },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteTripWithRouter);